module.exports = __webpack_public_path__ + "static/img/francesca_daisy.53ba50d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/francesca_daisy.png
// module id = VddB
// module chunks = 0